export default {
  sm: `
  네이버는 창사 이후 다양한 서비스를 
  출시하면서 <s>사용자와 데이터 용량이</s> 
  <s>급격하게 늘어났고, 자연히 IT인프라 </s>
  <s>규모도 계속 확장</s>했습니다. 
  `,
  lg: `
  네이버는 창사 이후 다양한 서비스를 출시하면서 <s>사용자와</s>
  <s>데이터 용량이 급격하게 늘어났고, 자연히 IT인프라 규모도</s> 
  <s>계속 확장</s>했습니다. 
  `,
};
